export const getCookie = (key: string): string | undefined => {
  if (typeof document === 'undefined') return undefined;

  const name = key + "=";
  const cDecoded = decodeURIComponent(document.cookie);
  const cArr = cDecoded.split("; ");
  for (const val of cArr) {
    if (val.indexOf(name) === 0) return val.substring(name.length);
  }
  return undefined;
};

export const setCookie = (name, value, days) => {
  let expires = '';

  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = '; expires=' + date.toUTCString();
  }

  document.cookie = name + '=' + (value || '') + expires + ';';
}
